<template>
  <div>
    <Movie
      v-if="element.component === 'movie'"
      :movieId="element.id"
      :videoId="element.main_video_id"
      :_movie="element"
    />
    <Picture
      v-else-if="element.component === 'picture'"
      :picture="element"
    />
    <div v-else>
      {{$t('video_watch.not_available')}}
    </div>
  </div>
</template>

<script>
import Picture from "./Picture/Container.vue"
import Movie from "./Movie/Container.vue"

export default {
  name: 'PostContainer',
  components: {Picture, Movie},
  props: {
    element: {},
    model: {}
  },
}
</script>
